"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var theme = {
  colorBorder: {
    normal: "rgba(0,0,0,0.12)",
    hover: "rgba(0,0,0,0.24)",
    active: "rgba(0,0,0,0.48)",
    focus: "rgba(0,0,0,0.24)"
  },
  toneValueHover: 0.04,
  toneValueActive: 0.08,
  toneValueFocus: 0.08,
  toneValueOverlay: 0.48,
  colorBgToolbar: {
    normal: "#2e72bf",
    hover: "#2864A8",
    active: "#235791"
  },
  colorBgSidebar: {
    normal: "transparent",
    hover: "rgba(0, 16, 61, 0.04)",
    active: "rgba(0, 16, 61, 0.08)"
  },
  depthSidebar: "none",
  depth0: "none",
  depth1: "0 2px 0 0 rgba(0, 16, 61, 0.04)",
  depth2: "0 4px 32px 0 rgba(0, 16, 61, 0.32)",
  depth3: "0 16px 48px 0 rgba(0, 0, 0, 0.48)",
  depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
  colorBgTint: "transparent",
  colorBgGradientTint: "transparent",
  colorStateHover: {
    normal: "rgba(0, 16, 61, 0.04)"
  },
  colorStateActive: {
    normal: "rgba(0, 16, 61, 0.08)"
  },
  colorOverlay: {
    normal: "rgba(0, 0, 0, 0.48)"
  },
  colorState: {
    normal: "#00103d"
  },
  colorLink: {
    normal: "#005bd1"
  },
  colorLinkVisited: {
    normal: "#528fdf"
  },
  colorIconFavorite: {
    normal: "#fc2c38",
    hover: "#F22B38",
    active: "#E82A38"
  },
  colorIconUnread: {
    normal: "#005ff9",
    hover: "#005CF1",
    active: "#0059EA"
  },
  colorBgPlaceholder: {
    normal: "#ffffff"
  },
  colorText: {
    normal: "#333333"
  },
  colorTextSecondary: {
    normal: "#999999"
  },
  colorTextSidebar: {
    normal: "#333333"
  },
  colorIcon: {
    normal: "#333333"
  },
  colorIconSecondary: {
    normal: "#c7c7c7",
    hover: "#BFC0C1",
    active: "#B7B8BC"
  },
  colorIconSidebar: {
    normal: "#333333"
  },
  colorBorderSidebar: {
    normal: "rgba(0,0,0,0.12)"
  },
  colorDivider: {
    normal: "rgba(0,16,61,0.12)"
  },
  colorScrollbar: {
    normal: "rgba(0, 16, 61, 0.48)"
  },
  colorPrimary: {
    normal: "#2e72bf",
    hover: "#2C6EBA",
    active: "#2A6AB5"
  },
  colorBg: {
    normal: "#ffffff",
    hover: "#F5F5F7",
    active: "#EBECEF"
  },
  colorBgHighlight: {
    normal: "#FFF1AD"
  },
  colorBgSecondary: {
    normal: "#f0f0f0",
    hover: "#E6E7E9",
    active: "#DDDEE2"
  },
  colorBgSecondaryFlat: {
    normal: "#f0f0f0",
    hover: "#E6E7E9",
    active: "#DDDEE2"
  },
  colorBgPopup: {
    normal: "#ffffff",
    hover: "#F5F5F7",
    active: "#EBECEF"
  },
  colorBgThumbnail: {
    normal: "rgba(0, 16, 61, 0.08)",
    hover: "rgba(0, 16, 61, 0.12)",
    active: "rgba(0, 16, 61, 0.16)"
  },
  colorCategoryMailings: {
    normal: "#FC8A15",
    hover: "#F28517",
    active: "#E88018"
  },
  colorCategorySocial: {
    normal: "#4F6DDC",
    hover: "#4C69D6",
    active: "#4966CF"
  },
  colorCategoryShopping: {
    normal: "#FF54AA",
    hover: "#F551A6",
    active: "#EB4FA1"
  },
  colorCategoryRegistrations: {
    normal: "#FF9E02",
    hover: "#F59804",
    active: "#EB9307"
  },
  colorCategoryFinance: {
    normal: "#07BB3F",
    hover: "#07B43F",
    active: "#06AD3F"
  },
  colorCategoryTicket: {
    normal: "#09A6FA",
    hover: "#09A0F2",
    active: "#089AEB"
  },
  colorCategoryTravel: {
    normal: "#BA34FC",
    hover: "#B333F4",
    active: "#AB31ED"
  },
  colorCategoryFees: {
    normal: "#E60000",
    hover: "#DD0102",
    active: "#D40105"
  }
};
exports.default = theme;